// extracted by mini-css-extract-plugin
export var animationBounceLeft = "animation-module--animation-bounce-left--3aed4";
export var bounceLeft = "animation-module--bounce-left--83293";